import React from 'react';
import { Box, Typography } from '@mui/material';
import { IDropdownOption } from '../../../../../types/commonTypes';
import DropdownWithChips from '../../../../reusable-components/dropdown-with-chips/DropdownWithChips';
import './filterField.scss';

interface EventStatusFilterFieldProps {
  value: string[];
  onChange: (values: string[]) => void;
}

const EventStatusFilterField: React.FC<EventStatusFilterFieldProps> = ({ value, onChange }) => {
  const statusOptions: IDropdownOption[] = [
    { id: 'Active', value: 'Active' },
    { id: 'Approved', value: 'Approved' },
    { id: 'Completed', value: 'Completed' },
  ];

  return (
    <Box className="filterField">
      <Typography className="filterFieldLabel">Event status</Typography>
      <Box className="filterFieldInput">
        <DropdownWithChips
          values={value}
          options={statusOptions}
          onChange={onChange}
          placeholder="Select"
          className="filterDropdown"
        />
      </Box>
    </Box>
  );
};

export default EventStatusFilterField;
